// ============================================================
// TPO Terminal — geteilte Typen + Timeframe-Tabelle
// ============================================================

export interface UniverseItem {
  symbol: string;     // BTCUSDT
  base: string;       // BTC
  name: string;       // Bitcoin
  rank: number;       // mcap-Rang
  tick_size: number;  // Bybit priceFilter.tickSize
}

export interface TickerMsg {
  type: 'ticker';
  symbol: string;
  last: number;
  changePct: number;
}

export interface KlineMsg {
  type: 'kline';
  symbol: string;
  interval: string;   // Bybit-Code
  openTime: number;   // ms
  o: number; h: number; l: number; c: number; v: number;
  confirmed: boolean;
}

export type MarketMsg = TickerMsg | KlineMsg;

// REST-Backfill-Bar
export interface Bar {
  openTime: number;   // ms
  o: number; h: number; l: number; c: number; v: number;
}

export interface Timeframe {
  label: string;      // Anzeige
  code: string;       // Bybit-Code (1,3,5,15,30,60,120,240,D)
  sec: number;        // Sekunden pro Bracket
}

export const TIMEFRAMES: Timeframe[] = [
  { label: '1m',  code: '1',   sec: 60 },
  { label: '3m',  code: '3',   sec: 180 },
  { label: '5m',  code: '5',   sec: 300 },
  { label: '15m', code: '15',  sec: 900 },
  { label: '30m', code: '30',  sec: 1800 },
  { label: '1h',  code: '60',  sec: 3600 },
  { label: '2h',  code: '120', sec: 7200 },
  { label: '4h',  code: '240', sec: 14400 },
  { label: '1d',  code: 'D',   sec: 86400 },
];

// Tagesgrenze fix 00:00 UTC; Anzeige in UTC+2.
export const DISPLAY_TZ_OFFSET_SEC = 2 * 3600;

// UTC-Sekunden → "HH:MM" bzw. "DD.MM" in UTC+2.
export function fmtTimeUTC2(utcSec: number, withDate = false): string {
  const d = new Date((utcSec + DISPLAY_TZ_OFFSET_SEC) * 1000);
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');
  if (withDate) {
    const D = String(d.getUTCDate()).padStart(2, '0');
    const M = String(d.getUTCMonth() + 1).padStart(2, '0');
    return `${D}.${M} ${hh}:${mm}`;
  }
  return `${hh}:${mm}`;
}

// UTC-Sekunden → "DD.MM" (bzw. "DD.MM.YY" für Jahres-Ticks) in UTC+2 — für die
// Zeitachse beim Rauszoomen.
export function fmtDateUTC2(utcSec: number, withYear = false): string {
  const d = new Date((utcSec + DISPLAY_TZ_OFFSET_SEC) * 1000);
  const D = String(d.getUTCDate()).padStart(2, '0');
  const M = String(d.getUTCMonth() + 1).padStart(2, '0');
  if (withYear) return `${D}.${M}.${String(d.getUTCFullYear()).slice(2)}`;
  return `${D}.${M}`;
}

export function fmtPrice(p: number, tick: number): string {
  if (!isFinite(p)) return '–';
  const dec = tick >= 1 ? 1 : tick >= 0.01 ? 2 : tick >= 0.0001 ? 4 : 6;
  return p.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
}
